import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, MailCheck } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { verifyEmailStart, verifyEmailConfirm, formatApiError } from "@/lib/api";

export function VerifyEmailDialog({ open, onOpenChange, onVerified }) {
  const [sent, setSent] = useState(null);
  const [otp, setOtp] = useState("");
  const [busy, setBusy] = useState(false);
  const [cd, setCd] = useState(0);
  useEffect(() => { if (!open) { setSent(null); setOtp(""); } }, [open]);
  useEffect(() => { if (cd <= 0) return undefined; const t = setTimeout(() => setCd(cd - 1), 1000); return () => clearTimeout(t); }, [cd]);
  const run = async (fn) => { setBusy(true); try { await fn(); } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); } };
  const send = () => run(async () => {
    const r = await verifyEmailStart();
    if (r.already_verified) { toast.success("Email pehle se verified hai"); onVerified?.(); onOpenChange(false); return; }
    setSent(r); setCd(r.cooldown || 60); toast.success(`OTP ${r.email} par bheja gaya`);
  });
  const confirm = () => run(async () => {
    await verifyEmailConfirm(otp);
    toast.success("Email verified");
    onVerified?.();
    onOpenChange(false);
  });
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm w-[calc(100vw-1.5rem)] p-4 sm:p-6" data-testid="verify-email-dialog">
        <DialogHeader>
          <DialogTitle className="text-base inline-flex items-center gap-2"><MailCheck className="w-4 h-4 text-emerald-700" /> Email verify karein</DialogTitle>
          <DialogDescription className="text-xs">Aapke registered email par 6-digit OTP bheja jaayega.</DialogDescription>
        </DialogHeader>
        {!sent ? (
          <button onClick={send} disabled={busy} className="w-full rounded-full bg-emerald-700 hover:bg-emerald-800 disabled:opacity-60 text-white px-4 py-3 text-sm font-semibold min-h-[44px]" data-testid="verify-email-send">
            {busy ? <Loader2 className="w-4 h-4 animate-spin mx-auto" /> : "OTP bhejein"}
          </button>
        ) : (
          <div className="space-y-3">
            <div className="text-xs text-slate-600" data-testid="verify-email-sent-to">OTP bheja gaya: <b>{sent.email}</b></div>
            <input value={otp} onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))} inputMode="numeric" autoComplete="one-time-code" placeholder="6-digit OTP"
              className="w-full border border-slate-200 rounded-xl px-3 py-3 text-base tracking-[0.3em] outline-none focus:border-emerald-500 min-h-[44px]" data-testid="verify-email-otp" />
            <div className="flex gap-2">
              <button onClick={send} disabled={busy || cd > 0} className="flex-1 rounded-full border border-slate-200 px-3 py-2.5 text-xs font-semibold disabled:opacity-50 min-h-[44px]" data-testid="verify-email-resend">{cd > 0 ? `Resend (${cd}s)` : "Resend OTP"}</button>
              <button onClick={confirm} disabled={busy || otp.length !== 6} className="flex-1 rounded-full bg-emerald-700 hover:bg-emerald-800 disabled:opacity-50 text-white px-3 py-2.5 text-sm font-semibold min-h-[44px]" data-testid="verify-email-confirm">
                {busy ? <Loader2 className="w-4 h-4 animate-spin mx-auto" /> : "Verify"}
              </button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
